<template>
    <div class="icon-validation" :style="`font-size: ${size}; `">
        <i v-if="status" success class="fas fa-check"></i>
        <i
            v-if="!status && status != undefined"
            danger
            class="far fa-times-circle"
        ></i>
    </div>
</template>

<script>
export default {
    name: 'ValidationInput',
    props: ['status', 'size'],
}
</script>

<style lang="sass" scoped>
.icon-validation
    position: absolute
    top: 0.2rem
    right: 0.4rem
[success]
    color: #359c61
[danger]
    color: #f05050
</style>
